import { Backdrop } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useUserContext } from "../../../contexts/UserContext";
import { UserActionTypes } from "../../../contexts/reducers/userReducer";
import useRefreshAccessMutation from "../../../hooks/graphql-hooks/mutations/useRefreshAccessMutation";
import { isNullOrEmpty } from "../../../utils/helper";
import PageLoader from "../../PageLoader";
import "./RefreshTokenBackdrop.scss";

interface RefreshTokenBackdropProps {}

const RefreshTokenBackdrop = () => {
  const { t } = useTranslation();
  const { user, dispatchUser } = useUserContext();

  const refreshAccessInput = {
    accessToken: user.accessToken || localStorage.getItem("accessToken") || "",
    refreshToken:
      user.refreshToken || localStorage.getItem("refreshToken") || "",
  };

  const [refreshMutation, {}] = useRefreshAccessMutation({
    dataAction: () => {},
    errorAction: () => dispatchUser({ type: UserActionTypes.Logout }),
  });

  useEffect(() => {
    if (
      isNullOrEmpty(refreshAccessInput.accessToken) ||
      isNullOrEmpty(refreshAccessInput.refreshToken)
    )
      return;

    refreshMutation().catch(() => {});
  }, []);

  return (
    <Backdrop
      className="refresh-backdrop"
      open={true}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="child" onClick={(event) => event.stopPropagation()}>
        <PageLoader text={t("loggingIn")} />
      </div>
    </Backdrop>
  );
};
export default RefreshTokenBackdrop;
